// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- No encuentra los ?react
//@ts-nocheck

import addChart from "./material-symbols--add-chart-outline.svg?react";
import addTask from "./material-symbols--add-task.svg?react";
import assignmentList from "./material-symbols--assignment-outline.svg?react";
import assignmentAdd from "./material-symbols--assignment-add-outline.svg?react";
import logout from "./material-symbols--logout.svg?react";
import newWindow from "./material-symbols--new-window.svg?react";
import postAdd from "./material-symbols--post-add.svg?react";
import resetSettings from "./material-symbols--reset-settings.svg?react";
import settings from "./material-symbols--settings.svg?react";
import speed from "./material-symbols--speed-outline.svg?react";
import tabNewRight from "./material-symbols--tab-new-right-outline.svg?react";
import hamburger from "./material-symbols--menu.svg?react";
import dashboardCustomize from "./material-symbols--dashboard-customize.svg?react";
import sortUp from "./material-symbols--sort-up.svg?react";
import sortDown from "./material-symbols--sort-down.svg?react";
import sortFilter from "./material-symbols--sort-filter.svg?react";
import calendar from "./material-symbols--calendar.svg?react";
import users from "./mdi--users.svg?react";
import chevronDown from "./chevronDown.svg?react";
import factory from "./Factory.svg?react";
import box from "./Box.svg?react";

export const AddChart = addChart as SVGComponent;
export const AddTask = addTask as SVGComponent;
export const AssignmentList = assignmentList as SVGComponent;
export const AssignmentAdd = assignmentAdd as SVGComponent;
export const Logout = logout as SVGComponent;
export const NewWindow = newWindow as SVGComponent;
export const PostAdd = postAdd as SVGComponent;
export const ResetSettings = resetSettings as SVGComponent;
export const Settings = settings as SVGComponent;
export const Speed = speed as SVGComponent;
export const TabNewRight = tabNewRight as SVGComponent;
export const Hamburger = hamburger as SVGComponent;
export const DashboardCustomize = dashboardCustomize as SVGComponent;
export const SortUp = sortUp as SVGComponent;
export const SortDown = sortDown as SVGComponent;
export const SortFilter = sortFilter as SVGComponent;
export const Calendar = calendar as SVGComponent;
export const Users = users as SVGComponent;
export const ChevronDown = chevronDown as SVGComponent;
export const Factory = factory as SVGComponent;
export const Box = box as SVGComponent;

type SVGComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;
